// extracted by mini-css-extract-plugin
export var body = "index-module--body--befaa";
export var single_member = "index-module--single_member--fbef6";
export var team_container = "index-module--team_container--8a50d";
export var team_grid = "index-module--team_grid--d2445";
export var title = "index-module--title--45c86";